// https://medium.com/@htomar/adding-type-safety-to-angular-material-dialog-%EF%B8%8F-45d72b8d16b

import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogWrapper } from './DialogWrapper';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private config: MatDialogConfig = {
    hasBackdrop: false,
    width: '480px',
  };
  constructor(private dialog: MatDialog) { }
  open<T extends DialogWrapper>(component: ComponentType<T>, data: { hasBackdrop?, data?: dialogData<T> } = {}) {
    const r = this.dialog.open<T, dialogData<T>, dialogReturn<T>>(component, {
      ...this.config,
      data: data.data
    });
    r.beforeClosed().subscribe(() => {
      r.componentInstance.open = false;
    });
    return r;
  }
}

type getRefReturn<T, K extends keyof T> = T[K] extends MatDialogRef<infer refT, infer refR>
  ? refR
  : never;
type filterRefProp<T> = {
  [K in keyof T]: T[K] extends MatDialogRef<any, any> ? K : never;
};

type propName<T> = filterRefProp<T>[keyof filterRefProp<T>];

type dialogReturn<T> = getRefReturn<T, propName<T>>;

type dialogData<T extends DialogWrapper<any, any, any>> = 'matDialogData' extends keyof T
  ? T['matDialogData']
  : never;